import { Spinner } from '@chakra-ui/react'
import type { FC } from 'react'

import BusinessContextContentPreview from '@app/pages/maps/components/businessContextContentPreview'
import ContextEditModal from '@app/pages/maps/components/contextEditModal'
import type { DomainBusinessContext } from '@app/types'

interface Props {
  loading?: boolean
  businessContext?: DomainBusinessContext
}

const ContextSectionContent: FC<Props> = ({ businessContext, loading = false }) => {
  if (loading) {
    return <Spinner />
  }

  return (
    <ContextEditModal businessContext={businessContext}>
      <BusinessContextContentPreview businessContext={businessContext} />
    </ContextEditModal>
  )
}

export default ContextSectionContent
